import { Control } from 'react-hook-form'

export const parseNumber = async (
  control: Control,
  event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>,
): Promise<number | undefined> => {
  const { value } = event.target

  if (value.trim() === '') return 0

  const result = Number(value.replace(/\s/g, '').replace(',', '.'))

  if (await control.trigger(event.target.name))
    return Number.isNaN(result) ? undefined : result

  return undefined
}
